import React from "react";
import { graphql } from "gatsby";
import { Grid, Button } from "semantic-ui-react";
import Helmet from "react-helmet";
import Markdown from "markdown-to-jsx";
import {
  PageLayout,
  HeroElement,
  Contact,
  ContactForm,
} from "@fishrmn/fishrmn-components";
import emailCallback from "../utils/email.js";

import AWS from "aws-sdk";

import Layout from "../components/Layout";
import { getPageHeroImages, getPageGalleryImages } from "../utils/images";

export default class extends React.PureComponent {
  render() {
    const data = this.props.data.allFisherman.edges[0].node;
    const pageData = this.props.data.fishermanWebsitePage;
    const pageComponents = (pageData && pageData.components) || [];

    return (
      <Layout>
        <Helmet>
          <title>{data.businessName} | Contact</title>
          <meta name="description" content={pageData.description} />
        </Helmet>
        <PageLayout
          hero={
            <HeroElement
              header={"Contact"}
              tagline={
                <>
                  <Button
                    as="a"
                    target="_blank"
                    href="https://www.google.com/maps/search/?api=1&query=4280 State Rd Peninsula, OH"
                  >
                    4280 State Rd Peninsula, OH
                  </Button>
                  <Button as="a" target="_blank" href="tel:+13309354444">
                    (330) 935-4444
                  </Button>
                </>
              }
              images={getPageHeroImages(pageComponents)}
              showMap={false}
              ctas={[data.ctas.address, data.ctas.phone]}
              ctaInverted={true}
              ctaColor={"white"}
              containerColor={"primary"}
              textColor={"white"}
              showMultiple={true}
              overlay={true}
              fullWidth={true}
              parallax={false}
              containerAs={"none"}
              height={"100vh"}
              gutter={false}
            />
          }
        >
          <Grid stackable className="component-section-container">
            <Grid.Column width={16}>
              <Contact
                phoneNumber={data.phone}
                email={data.email}
                address={{
                  street: data.address.street,
                  city: data.address.city,
                  state: data.address.state,
                  zip: data.address.zip,
                }}
                hours={data.hours}
                as={"text"}
                buttonColor={"secondary"}
                header={"Contact"}
                image={""}
                showMap={true}
              />
              <Contact
                phoneNumber={data.locations[1].phoneNumber}
                address={{
                  street: data.locations[1].address.street,
                  city: data.locations[1].address.city,
                  state: data.locations[1].address.state,
                  zip: data.locations[1].address.zip,
                }}
                hours={data.hours}
                as={"text"}
                buttonColor={"secondary"}
                header={"Contact"}
                image={""}
                showMap={true}
              />
            </Grid.Column>
          </Grid>
          <Grid
            stackable
            className="component-section-container"
            verticalAlign={"middle"}
            textAlign={"left"}
          >
            <Grid.Column width={16}>
              <ContactForm
                businessId={3241}
                businessType="restaurant"
                locationId={3046}
                buttonText={"Send"}
                centeredHeaders={true}
                className={""}
                fluidButton={false}
                header={"Contact Us"}
                inline={false}
                showLabels={true}
                subheader={""}
                termsCopy={""}
                withContainer={true}
              />
            </Grid.Column>
          </Grid>
        </PageLayout>
      </Layout>
    );
  }
}

export const query = graphql`
  query {
    allFisherman {
      edges {
        node {
          ctas {
            address {
              link
              text
              internal
            }
            phone {
              link
              text
              internal
            }
          }
          locations {
            address {
              city
              state
              street
              zip
            }
            hours {
              close
              day
              open
              label
            }
            phoneNumber
          }
          businessName
          phone
          email
          address {
            street
            city
            state
            zip
          }
          hours {
            open
            close
            day
          }
        }
      }
    }
    fishermanWebsitePage(pageType: { eq: "Contact" }) {
      description
      components {
        fastId
        order
        files {
          file
        }
      }
    }
  }
`;
